export default function scrollToRightSide(block) {
  const screenWidth = document.documentElement.clientWidth;
  const blockRightOffset = block.getBoundingClientRect().right;
  const scrollOffset = screenWidth - blockRightOffset;
  window.scrollTo(0, window.scrollY - scrollOffset);
}
